import { gql } from "@apollo/client";

export const SystemInstalledBaseNodeId = gql`
    query SystemInstalledBaseNodeId($id: ID!) {
        system(id: $id) {
            id
            installedBaseNode {
                id
            }
        }
    }
`;
